module.exports = __webpack_public_path__ + "static/img/r-2-2-icon.ff1e271.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-2/r-2-2-icon.png
// module id = 82Uk
// module chunks = 0